import moment from 'moment';
import React, { useEffect } from 'react';
import { View, Image } from 'react-native';
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from "../../../constants/Colorsv2"
import { Text, TouchableOpacity } from "../../../globalComponents/NativeOverrides"
import { comps_getCompetitionOptions, comps_getCompetitionResultsByCompetitionId } from '../../../store/actionsv1/comps';
import { player_getBulkPlayers } from '../../../store/actionsv1/player';
import { PublicPlayerProps } from '../../../store/types/auth_svc';
import { CompetitionPayoutTypeProps, CompetitionPlayerProps, CompetitionProps, CompetitionRecordProps, CompetitionResultProps, CompetitionResultTypeProps, CompetitionTypeProps } from "../../../store/types/tp_svc"
import { comp_getCompColors } from '../helpers/competition';

type CompetitionCardProps = {
    competition:CompetitionProps,
    min_width?:number,
    onSelect:(competition:CompetitionProps) => void
}
const CompetitionCard = ({ competition, onSelect, min_width }:CompetitionCardProps) => {
    
    const dispatch = useDispatch();
    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const stored_results:{ updated:number, results: CompetitionResultProps[] } = useSelector((state:any) => state.comp.stored_results, (left, right) => left.updated == right.updated)
    const competition_result = stored_results.results.find((cr:CompetitionResultProps) => cr.competition_id == competition.competition_id && cr.status !== 'deleted' && cr.player_id == player?.player_id)
    const admin:PublicPlayerProps | undefined = useSelector((state:any) => state.social.stored_players.find(p => p.player_id == competition.admin_id), (left, right) => left?.player_id == right?.player_id)
    const sponsor:PublicPlayerProps | undefined = useSelector((state:any) => state.social.stored_players.find(p => p.player_id == competition.sponsor_id), (left, right) => left?.player_id == right?.player_id)
    const pacer:PublicPlayerProps | undefined = useSelector((state:any) => state.social.stored_players.find(p => p.player_id == competition.pacer_id), (left, right) => left?.player_id == right?.player_id)
    const competition_records_store:{ updated:number, records: CompetitionRecordProps[] } = useSelector((state:any) => state.comp.stored_records, (left, right) => left.updated == right.updated)
    const competition_record = competition_records_store.records.find((cr:CompetitionRecordProps) => cr.competition_id == competition.competition_id && cr.player_id == player?.player_id && cr.status !== 'deleted')
    const competition_type:CompetitionTypeProps = useSelector((state:any) => state.comp.competition_types.find((ct:CompetitionTypeProps) => ct.competition_type_id == competition.competition_type_id))
    const competition_result_type:CompetitionResultTypeProps = useSelector((state:any) => state.comp.competition_result_types.find((cp:CompetitionPayoutTypeProps) => cp.competition_result_type_id == competition.competition_result_type_id))
    const comp_colors = comp_getCompColors(competition_type, competition)
    const invited_competition_player:CompetitionPlayerProps | undefined = useSelector((state:any) => state.comp.invited_competition_players.find((cp:CompetitionPlayerProps) => cp.competition_id == competition.competition_id && cp.status === 'invited'), (left, right) => left?.status == right?.status)

    useEffect(() => {
        //if(!competition.entered){ return }
        getDataFromServer()
    },[competition.entered])

    const getDataFromServer = async() => {
        if(competition?.entered && !competition_result){ await dispatch(comps_getCompetitionResultsByCompetitionId(competition.competition_id, 1, player?.player_id)) }
        if(!competition_type){ await dispatch(comps_getCompetitionOptions()) }
    }

    const cl = competition.market_type === 'FOR_MONEY' ? '$' : 'E'
    let total_payout = competition.ticket_revenue
    if(competition.promo_payout && competition.promo_payout > 0){
        total_payout += competition.promo_payout
    }

    if(competition.guaranteed_payout){
        if(total_payout < competition.guaranteed_payout){ total_payout = competition.guaranteed_payout }
    }

    return (
        <TouchableOpacity nativeID="competition_card" style={{ flex:1, borderRadius:8, borderWidth:1, backgroundColor:comp_colors.backgroundColor, borderColor:comp_colors.borderColor, minWidth:min_width??undefined, flexShrink:0 }} onPress={() => onSelect(competition)}>
            <View style={{ flexDirection:'row', alignItems:'center' }}>
                <View style={{backgroundColor:comp_colors.borderColor, borderTopLeftRadius:8, padding:6, paddingLeft:10, borderWidth:1, borderColor:comp_colors.borderColor}}>
                    <Text size={10} color={Colors.shades.white} weight='bold'>{competition_type?.type_label??'...'} - {competition_result_type?.label}</Text>
                </View>
                {competition.invite_only?
                <View style={{flexDirection:'row', alignItems:'center', justifyContent:'flex-end', paddingRight:10}}>
                    <Text size={10} textAlign='right' color={Colors.accents.accent100}>PRIVATE</Text>
                    <Icon containerStyle={{marginLeft:4}} name='eye-off' type='feather' size={10} color={Colors.accents.accent100} />
                </View>
                :
                <View style={{flexDirection:'row', alignItems:'center', justifyContent:'flex-end', paddingRight:10}}>
                    <Text size={10} textAlign='right' color={Colors.accents.accent100}>PUBLIC</Text>
                    <Icon containerStyle={{marginLeft:4}} name='users' type='feather' size={10} color={Colors.accents.accent100} />
                </View>
                }
            </View>
            <View style={{ flex:1, padding:12}}>
                {!competition.sponsor_id?
                <View style={{flexDirection:'row', alignItems:'center', justifyContent:'flex-start'}}>
                    <Image style={{height:24, width:24, borderRadius:100}} source={admin?.profile_pic?{ uri: admin.profile_pic }:require('../../../assets/images/default-avatar.png')} />
                    <Text size={12} color={Colors.brand.midnight} style={{ marginLeft:6 }}>{admin?.first_name} {admin?.last_name}</Text>
                </View>
                :
                <View style={{flexDirection:'row', alignItems:'center', justifyContent:'flex-start'}}>
                    <Image style={{height:24, width:24, borderRadius:100}} source={sponsor?.profile_pic?{ uri: sponsor?.profile_pic }:require('../../../assets/images/default-avatar.png')} />
                    <Text size={12} color={Colors.brand.midnight} style={{ marginLeft:6 }}>{sponsor?.first_name} {sponsor?.last_name}</Text>
                </View>
                }
                {competition.promo_payout?
                    <Text size={12} color={Colors.brand.midnight} weight='bold' style={{ marginTop:4 }}>${competition.promo_payout.toFixed(2)} Added To Payout</Text>
                :<></>}
                <Text size={12} color={Colors.highlights.highlight200} style={{ marginTop:4 }}>{moment(competition.scheduled_datetime).format('MMM DD - hh:mm a')}</Text>
                <View style={{width:40, height:1, borderBottomWidth:1, borderBottomColor:Colors.accents.accent200, justifyContent:'center', alignSelf:'flex-start', marginTop:8, marginBottom:4}} />
                <Text size={12} color={Colors.brand.electric} weight='semibold' style={{ marginTop:4 }}>{competition.competition_name}</Text>
                {competition.competition_description ?
                <Text size={12} color={Colors.brand.electric} weight='regular' style={{ marginTop:4 }}>{competition.competition_description.substring(0,30)}...</Text>
                :<></>}
                {competition.pacer_id && pacer?
                <Text size={12} color={Colors.brand.midnight} style={{ marginTop:4 }}>Pacer: @{pacer?.username}</Text>
                :<></>}
                {competition_type?.type === 'pick' ?
                <Text size={12} color={Colors.brand.midnight} style={{ marginTop:4 }}>Picks: {competition.max_pick_count}</Text>
                :
                <Text size={12} color={Colors.brand.midnight} style={{ marginTop:4 }}>Starting Balance: {competition.initial_balance}</Text>
                }
                <Text size={12} color={Colors.brand.midnight} style={{ marginTop:4 }}>Ticket Price: {cl}{competition.buy_in}</Text>
                <Text size={12} color={Colors.brand.midnight} style={{ marginTop:4 }}>Available Tickets: {competition.available_tickets - competition.tickets_sold}</Text>
                {competition_result ? 
                    <Text size={12} color={Colors.brand.electric} weight='semibold' style={{marginTop:4}}>Place: {competition_result.place} of {competition.tickets_sold} ({cl}{competition_result.winnings.toFixed(2)})</Text>
                :<></>}
                {competition_record && competition_type?.type === 'pick' ?
                    <Text size={12} color={Colors.brand.electric} weight='semibold' style={{marginTop:4}}>Record: {competition_record.wins} - {competition_record.losses} - {competition_record.draws}</Text>
                :<></>}
            </View>
            {competition.prize_override ?
            <View style={{ flexDirection:'row', alignItems:'center', backgroundColor:Colors.incentive.gold_faded, borderBottomRightRadius:8, borderBottomLeftRadius:8, padding:5 }}>
                    {competition.prize_image ?
                    <Image
                        source={{ uri: competition.prize_image.url }}
                        style={{ height:25, width:25, borderRadius:4, marginRight:10 }}
                        resizeMode='cover'
                    />
                    :<></>}
                    <Text size={12} color={Colors.brand.midnight} weight='bold'>{competition.prize_override}</Text>
            </View>
            :<></>}
            {total_payout > 0 ?
            <View style={{ flexDirection:'row', alignItems:'center', backgroundColor:Colors.incentive.gold_faded, borderBottomRightRadius:8, borderBottomLeftRadius:8, padding:5 }}>
                <Text style={{ flex:1 }} size={14} color={Colors.brand.midnight} weight='regular'>Current Payout:</Text>
                <Text size={14} color={Colors.brand.midnight} weight='bold'>{cl}{total_payout.toFixed(2)}</Text>
            </View>
            :<></>}
            {!competition.entered && invited_competition_player ?
            <View style={{ position:'absolute', bottom:5, right:5, backgroundColor:Colors.shades.white, borderRadius:20, padding:5 }}>
                <Text style={{ paddingRight:5, paddingLeft:5 }} size={12} weight='semibold' color={Colors.brand.midnight}>Invited by {admin?.username??'...'}</Text>
            </View>
            :<></>}
            {competition.entered ?
            <View style={{ position:'absolute', top:5, right:5, backgroundColor:Colors.brand.midnight, borderRadius:20, padding:5 }}>
                <Text style={{ paddingRight:5, paddingLeft:5 }} size={12} weight='semibold' color={Colors.shades.white}>ENTERED</Text>
            </View>
            :<></>}
        </TouchableOpacity>
    )
}



export default CompetitionCard